// removed by extract-text-webpack-plugin
module.exports = {"selectedLager":"selectedLager__2qxWG"};